export default {
  isLoggedIn(state){
      return !!state.userId
  },

  role(state){
    return state.role
  }
};
